import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface CartStateInterface {
  productsQuantity: number
  cartItems: Record<string, number>
  duplicateProductsQuantities: {
    [key: string]: number
  }

  selectedProductKeys: string[]

  setDuplicateProductsQuantities: (productKey: string, quantity: number) => void

  selectedAuthorIds: string[]

  setProductsQuantity: (quantity: number) => void

  setSelectedProductKeys: (keys: string[]) => void
  clearSelectedProducts: () => void

  setSelectedAuthorIds: (ids: string[]) => void

  setInitialCartStore: () => void
}

const initialState = {
  duplicateProductsQuantities: {},
  productsQuantity: 0,
  cartItems: {},
  selectedProductKeys: [],
  selectedAuthorIds: [],
}

export const useCartStore = create<CartStateInterface>()(
  persist(
    (set) => ({
      ...initialState,
      setDuplicateProductsQuantities: (
        productKey: string,
        quantity: number
      ) => {
        set((state) => ({
          duplicateProductsQuantities: {
            ...state.duplicateProductsQuantities,
            [productKey]: quantity,
          },
        }))
      },
      setProductsQuantity: (quantity: number) => {
        set(() => ({ productsQuantity: quantity }))
      },

      setSelectedProductKeys: (keys: string[]) => {
        set(() => ({ selectedProductKeys: keys }))
      },
      clearSelectedProducts: () => {
        set(() => ({ selectedProductKeys: [] }))
      },
      setSelectedAuthorIds: (ids: string[]) => {
        set(() => ({ selectedAuthorIds: ids }))
      },

      setInitialCartStore: () => set({ ...initialState }),
    }),
    {
      name: 'cart-storage',
      partialize: (state) => ({
        selectedProductKeys: state.selectedProductKeys,
        duplicateProductsQuantities: state.duplicateProductsQuantities,
        selectedAuthorIds: state.selectedAuthorIds,
      }),
    }
  )
)
